import React from "react";
import { getWindowWidth, isSearchMobile } from "../../../../services";
import MobileModuleAllSearchControls from "./MobileModuleAllSearchControls";
import MobileModuleSearchGroup from "./MobileModuleSearchGroup";
import ModuleAllSearchControls from "./ModuleAllSearchControls";
import ModuleSearchGroup from "./ModuleSearchGroup";

const ModuleSearchGroups = props => {
  const {
    groupConfigs,
    form,
    onSubmit,
    onReset,
    numberOfControls,
    renderCategorySelector,
    showAllControls,
    closeAllSearch
  } = props;

  if (groupConfigs.length === 0) {
    return null;
  }

  const isMobile = isSearchMobile(getWindowWidth());

  // When the detailed-search panel opens, hide the always-visible quick
  // search bar (*SearchGroup) and let *AllSearchControls render every group,
  // turning the primary fields into the first "Osnovni podaci" accordion.
  return (
    <React.Fragment>
      {!showAllControls && (
        isMobile ? (
          <MobileModuleSearchGroup
            form={form}
            groupConfig={groupConfigs[0]}
            onSubmit={onSubmit}
            onReset={onReset}
            isMobile={isMobile}
            renderCategorySelector={renderCategorySelector}
            showAllControls={showAllControls}
          />
        ) : (
          <ModuleSearchGroup
            form={form}
            groupConfig={groupConfigs[0]}
            onSubmit={onSubmit}
            onReset={onReset}
            isMobile={isMobile}
            renderCategorySelector={renderCategorySelector}
            showAllControls={showAllControls}
          />
        )
      )}

      {isMobile ? (
        <MobileModuleAllSearchControls
          form={form}
          onSubmit={onSubmit}
          groupConfigs={groupConfigs}
          isMobile={isMobile}
          numberOfControls={numberOfControls}
          renderCategorySelector={renderCategorySelector}
          showAllControls={showAllControls}
          closeAllSearch={closeAllSearch}
        />
      ) : (
        <ModuleAllSearchControls
          form={form}
          onSubmit={onSubmit}
          groupConfigs={groupConfigs}
          isMobile={isMobile}
          numberOfControls={numberOfControls}
          renderCategorySelector={renderCategorySelector}
          showAllControls={showAllControls}
          closeAllSearch={closeAllSearch}
        />
      )}
    </React.Fragment>
  );
};

export default ModuleSearchGroups;



// WEBPACK FOOTER //
// ./src/containers/ModulePage/ModuleSeaarchSection/ModuleSearchGroups/inde.tsx